<form [formGroup]="form" (ngSubmit)="onSave()">
	@if (httpError == '400') {
		<mat-error class="top-right-absolute-error-message">
			{{ 'mes.administration.terminal.shared.errors.bad-request' | translate }}
		</mat-error>
	}
	@if (httpError == '500') {
		<mat-error class="top-right-absolute-error-message">
			{{ 'mes.administration.terminal.shared.errors.internal-server-error' | translate }}
		</mat-error>
	}

	<h1 mat-dialog-title class="notification-title no-select">
		{{ 'mes.administration.terminal.create.window-header' | translate }}
	</h1>

	<mat-dialog-content style="padding-top: 20px">
		<div class="optional-form-fields">
			@if (httpError == '409') {
				<mat-error>
					{{ 'mes.administration.terminal.shared.errors.duplicate' | translate }}
				</mat-error>
			}
			@if (controls['alias'].invalid && controls['alias'].touched) {
				<mat-error>
					{{ 'mes.administration.terminal.dialog.alias.error.' + getFirstValidationErrorName('alias') | translate }}
				</mat-error>
			}
			<mat-form-field appearance="outline" class="dialog">
				<mat-label class="mat-body-1">
					{{ 'mes.administration.terminal.shared.alias' | translate }}
				</mat-label>
				<input maxlength="255" matInput formControlName="alias" />
			</mat-form-field>

			@if (controls['name'].invalid && controls['name'].touched) {
				<mat-error>
					{{ 'mes.administration.terminal.dialog.name.error.' + getFirstValidationErrorName('name') | translate }}
				</mat-error>
			}
			<mat-form-field appearance="outline" class="dialog">
				<mat-label class="mat-body-1">
					{{ 'mes.administration.terminal.shared.name' | translate }}
				</mat-label>
				<input maxlength="255" matInput formControlName="name" />
			</mat-form-field>

			<mat-form-field appearance="outline" class="dialog">
				<mat-label class="mat-body-1">
					{{ 'mes.administration.terminal.completion-flow.label' | translate }}
				</mat-label>
				<mat-select formControlName="completionFlow">
					@for (flow of completionFlows; track flow) {
						<mat-option [value]="flow">
							{{ 'mes.administration.terminal.completion-flow.types.' + flow.toLowerCase() | translate }}
						</mat-option>
					}
				</mat-select>
			</mat-form-field>

			<mat-form-field appearance="outline" class="dialog">
				<mat-label class="mat-body-1">
					{{ 'mes.administration.terminal.completion-group-type.label' | translate }}
				</mat-label>
				<mat-select formControlName="completionGroupType">
					@for (groupType of completionGroupTypes; track groupType) {
						<mat-option [value]="groupType">
							{{ 'mes.administration.terminal.completion-group-type.types.' + groupType.toLowerCase() | translate }}
						</mat-option>
					}
				</mat-select>
			</mat-form-field>

			@if (controls['stationFilter'].invalid) {
				<mat-error>
					{{ 'mes.administration.terminal.dialog.stationFilter.error.' + getFirstValidationErrorName('stationFilter') | translate }}
				</mat-error>
			}
			<mat-form-field appearance="outline" class="dialog">
				<mat-label class="mat-body-1">
					{{ 'mes.administration.terminal.shared.stationFilter' | translate }}
				</mat-label>
				<input maxlength="255" matInput formControlName="stationFilter" />
			</mat-form-field>

			<mat-form-field appearance="outline" class="dialog">
				<mat-label class="mat-body-1">
					{{ 'mes.administration.terminal.shared.terminal-template' | translate }}
				</mat-label>
				<mat-select formControlName="terminalTemplateId">
					@for (terminalTemplate of terminalTemplates; track terminalTemplate) {
						<mat-option [value]="terminalTemplate.id">
							({{ terminalTemplate.alias }})
							{{ terminalTemplate.name }}
						</mat-option>
					}
				</mat-select>
			</mat-form-field>

			<mat-form-field appearance="outline" class="dialog">
				<mat-label class="mat-body-1">
					{{ 'mes.administration.terminal.shared.next-terminal' | translate }}
				</mat-label>
				<mat-select formControlName="nextId">
					@for (terminal of terminals; track terminal) {
						<mat-option [value]="terminal.id">({{ terminal.alias }}) {{ terminal.name }}</mat-option>
					}
				</mat-select>
			</mat-form-field>

			<mat-form-field appearance="outline" class="dialog">
				<mat-label class="mat-body-1">
					{{ 'mes.administration.terminal.create.sql-query' | translate }}
				</mat-label>
				<textarea maxlength="200000" matInput formControlName="sqlQuery" class="vertical-resize"></textarea>
			</mat-form-field>

			<div class="mat-form-field-wrapper-styles">
				<label class="mat-body-1 mat-form-field-label">
					{{ 'mes.administration.terminal.shared.worktasks' | translate }}
				</label>

				<app-item-select-control formControlName="workTaskCategories" [availableOptions]="categories" [availableLabelKey]="'mes.administration.terminal.shared.all-categories'" [selectedLabelKey]="'mes.administration.terminal.shared.selected-categories'"></app-item-select-control>
			</div>

			<div class="mat-form-field-wrapper-styles">
				<label class="mat-body-1 mat-form-field-label">
					{{ 'mes.administration.terminal.shared.incident-codes' | translate }}
				</label>

				<app-item-select-control formControlName="incidentCodeGroups" [availableOptions]="incidentCodeGroups" [availableLabelKey]="'mes.administration.terminal.shared.all-categories'" [selectedLabelKey]="'mes.administration.terminal.shared.selected-categories'"></app-item-select-control>
			</div>

			<app-list-print-configuration [terminalConfig]="{ id: null, stationFilter: form.get('stationFilter')?.value }" [initialPrintConfigurations]="terminal.printConfigurations"></app-list-print-configuration>
		</div>
	</mat-dialog-content>
	<div>
		<div mat-dialog-actions align="end">
			<button mat-flat-button color="primary" type="submit" [disabled]="loading || form.invalid">
				{{ 'mes.administration.terminal.shared.okbtn' | translate }}
			</button>
			<button mat-stroked-button type="button" (click)="onCancel()" (window:keyup.escape)="onCancel()" class="button-border-color">
				{{ 'mes.administration.terminal.shared.cancelbtn' | translate }}
			</button>
		</div>
	</div>
</form>
